import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import columnHeader from './model/ColumnHeader';

@Component({
  selector: 'app-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.scss']
})
export class DataGridComponent implements OnInit{
  @Input()
  vista:string=""

  @Input()
  dataHeadersGrid:columnHeader[]=[]
  
  @Input()
  dataGrid:any[]=[]

  @Output()
  refreshLista = new EventEmitter<string>();

  @Output()
  edit = new EventEmitter<any>();

  @Output()
  delete = new EventEmitter<any>();

  @Output()
  redirect = new EventEmitter<any>();

  @Output()
  aprobarAP = new EventEmitter<any>();

  @Output()
  modal = new EventEmitter<any>();

  @Output()
  modalClose = new EventEmitter<any>();

  @Output()
  extinguir = new EventEmitter<any>();

  @Output()
  cartaNoAdeudo = new EventEmitter<any>();

  @Output()
  anularExOp = new EventEmitter<any>();

  @Output()
  sort = new EventEmitter<any>();



  constructor() { }

  ngOnInit(): void {
    
  }

  anularExtincion(row:any){
    this.anularExOp.emit(row)
  }

  generarCartaNoAdeudo(row:any){
    this.cartaNoAdeudo.emit(row)
  }

  refreshPagination(info:any){
    this.refreshLista.emit(info)
  }

  editRow(row:any){
    this.edit.emit(row)
  }

  deleteRow(row:any){
    this.delete.emit(row)
  }

  sortRow(row:any){
    this.sort.emit(row)
  }

  goTo(row:any){
    this.redirect.emit(row)
  }

  extinguirOperacion(row:any){
    this.extinguir.emit(row)
  }

  aprobarAcuerdo(row:any){
    this.aprobarAP.emit(row)
  }

  openModal(row:any){
    this.modal.emit(row)
  }

  closeModal(row:any){
    this.modalClose.emit(row)
  }
}


